angular.module('octopusApp.shared')
    .directive("noDirtyCheck", function noDirtyCheck() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, elem, attrs, ctrl) {
                var alwaysFalse = {
                    get: function () {
                        return false;
                    },
                    set: function () {
                    }
                };
                Object.defineProperty(ctrl, '$pristine', alwaysFalse);
                Object.defineProperty(ctrl, '$dirty', alwaysFalse);
            }
        };
    });



//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/directives/no-dirty-check.js
// module id = 595
// module chunks = 1